// extracted by mini-css-extract-plugin
export default {"wrapper":"D9IA5","content":"Ko_MD","button":"OkTFf"};